<template>
	<div class="merchant_content">
		<div class="payment_list_wrap">
			<div v-if="isShowList">
				<div class="search_date">
					<div class="d_flex">
						<div class="info mr_8">
							<date-picker
								is-required
								v-model="startDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											:value="inputValue"
											v-on="inputEvents"
										/>
									</label>
								</template>
							</date-picker>
						</div>
						<div class="info">
							<date-picker
								is-required
								v-model="endDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											id="calendar_area"
											:value="inputValue"
											v-on="inputEvents"
										/>
									</label>
								</template>
							</date-picker>
						</div>
					</div>

					<div class="d_flex">
						<a @click="reLoad">
							<span class="icon RELOAD"></span>
						</a>
						<a @click="detailSearchModal = true">
							<span class="icon DETAIL"></span>
						</a>
					</div>
				</div>

				<div class="summary">
					<p class="total">
						{{ $t('merchant_management.payment_list.detail.total_payment') }}
						<span>
							<!--							{{ pageNavigation.total_count }}-->
							{{ summary.count }}
							{{ $t('merchant_management.payment_list.count') }}
						</span>
					</p>
					<p class="total">
						{{ $t('merchant_management.payment_list.detail.total_amount') }}
						<span>{{ summary.sum }} JPYS</span>
					</p>
					<p class="mb_4">
						{{ $t('merchant_management.payment_list.detail.complete_payment') }}
						{{ completeCount
						}}{{ $t('merchant_management.payment_list.count') }}
					</p>
					<p>
						{{ $t('merchant_management.payment_list.detail.refund') }}
						{{ refundCount }}{{ $t('merchant_management.payment_list.count') }}
					</p>
				</div>

				<!--				<h5 class="date">2022.08.14</h5>-->

				<div v-if="transactionList.length === 0" class="list_none">
					<span class="ERRORGRAY"></span>
					<p>
						{{ $t('merchant_management.payment_list.detail.no_payment_count') }}
					</p>
				</div>

				<div v-else class="detail_area">
					<!-- 거래 내역 리스트 영역 -->
					<div
						class="detail_box"
						v-for="item in transactionList"
						:key="item.seq"
						@click="showDetail(item)"
					>
						<div class="items">
							<p>
								{{
									$t('merchant_management.payment_list.detail.merchant_name')
								}}
							</p>
							<p class="text_1">
								{{ $store.state.auth.merchantInfo.merchant_name }}
							</p>
						</div>
						<div class="items">
							<p>{{ $t('merchant_management.payment_list.table.id') }}</p>
							<p class="text_1">{{ item.transaction_id }}</p>
						</div>
						<div class="items">
							<p>{{ $t('merchant_management.payment_list.table.name') }}</p>
							<p class="text_1">{{ item.title }}</p>
						</div>
						<div class="items">
							<p>
								{{
									$t('merchant_management.payment_list.detail.payment_assets')
								}}
							</p>
							<p class="text_1">{{ item.asset_code }}</p>
						</div>
						<div class="items">
							<p>{{ $t('merchant_management.payment_list.table.type') }}</p>
							<p class="text_1">{{ item.transaction_type }}</p>
						</div>
						<div class="items">
							<p>{{ $t('merchant_management.payment_list.table.amount') }}</p>
							<p class="text_1">{{ item.amount + ' ' + item.asset_code }}</p>
						</div>
						<div class="items">
							<p v-if="item.transaction_type === 'PAYMENT'">
								{{ $t('merchant_management.payment_list.detail.payment_date') }}
							</p>
							<p v-else>
								{{ $t('merchant_management.payment_list.detail.refund_date') }}
							</p>
							<p class="text_1">
								{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
							</p>
						</div>
					</div>
					<button
						v-if="!isRemain"
						class="merchant_button bg_red mt_40"
						@click="pageChangeHandler"
					>
						{{ $t('button.more') }}
					</button>
				</div>
			</div>

			<div v-if="!isShowList" class="item_detail">
				<div class="detail_title" @click="back">
					<span class="icon LEFTARROW mr_8"></span>
					<h3 class="title_s">
						{{ $t('merchant.transaction.text4') }}
					</h3>
				</div>
				<div class="bg_black_box">
					<div class="box_item">
						<p>
							{{ $t('merchant_management.payment_list.detail.merchant_name') }}
						</p>
						<p>{{ $store.state.auth.merchantInfo.merchant_name }}</p>
					</div>
					<div class="box_item">
						<p>{{ $t('merchant.picker.merchant_id') }}</p>
						<p>{{ $store.state.auth.merchantInfo.merchant_id }}</p>
					</div>
					<span class="divide_line"></span>
					<div class="box_item">
						<p>{{ $t('merchant_management.payment_list.order_number') }}</p>
						<p>{{ transactionInfo.order_id }}</p>
					</div>
					<div class="box_item">
						<p>{{ $t('merchant_management.payment_list.table.name') }}</p>
						<p>{{ transactionInfo.title }}</p>
					</div>
					<div class="box_item">
						<p>{{ $t('merchant_management.payment_list.table.id') }}</p>
						<p>{{ transactionInfo.transaction_id }}</p>
					</div>
					<div class="box_item">
						<p>
							{{ $t('merchant_management.payment_list.detail.payment_assets') }}
						</p>
						<p>{{ transactionInfo.asset_code }}</p>
					</div>
					<div class="box_item">
						<p>{{ $t('merchant_management.payment_list.table.amount') }}</p>
						<p>{{ transactionInfo.amount }}</p>
					</div>
					<div class="box_item">
						<p>{{ $t('merchant_management.payment_list.table.payer') }}</p>
						<p>{{ transactionInfo.payer_name }}</p>
					</div>
					<span class="divide_line"></span>
					<div class="box_item">
						<p>{{ $t('merchant_management.payment_list.table.type') }}</p>
						<p>{{ transactionInfo.transaction_type }}</p>
					</div>
					<div class="box_item">
						<p v-if="transactionInfo.transaction_type === 'PAYMENT'">
							{{ $t('merchant_management.payment_list.detail.payment_date') }}
						</p>
						<p v-else>
							{{ $t('merchant_management.payment_list.detail.refund_date') }}
						</p>
						<p>
							{{
								$dayjs(transactionInfo.regdate).format('YYYY.MM.DD HH:mm:ss')
							}}
						</p>
					</div>
				</div>
				<button
					v-if="transactionInfo.transaction_type === 'PAYMENT'"
					class="merchant_button border_red mt_40"
					@click="checkRefundModal = true"
				>
					{{ $t('merchant_management.payment_list.detail.refund') }}
				</button>
			</div>
		</div>
	</div>
	<ModalViewM v-if="detailSearchModal" @closeModal="detailSearchModal = false">
		<template #title>
			<h3 class="modal_title_m mb_16">
				{{ $t('merchant_management.payment_list.modal.title') }}
			</h3>
		</template>
		<DetailSearchComponent @searchData="searchData"></DetailSearchComponent>
	</ModalViewM>
	<ModalViewM v-if="checkRefundModal" @closeModal="checkRefundModal = false">
		<template #title>
			<h3 class="modal_title_m mb_16">
				{{ $t('merchant_management.payment_list.detail.refund') }}
			</h3>
		</template>
		<div class="bg_black_box">
			<div class="box_item">
				<p>{{ $t('merchant_management.payment_list.order_number') }}</p>
				<p>{{ transactionInfo.order_id }}</p>
			</div>
			<div class="box_item">
				<p>{{ $t('merchant_management.payment_list.table.payer') }}</p>
				<p>{{ transactionInfo.payer_name }}</p>
			</div>
			<div class="box_item">
				<p>
					{{ $t('merchant_management.payment_list.detail.payment_assets') }}
				</p>
				<p>{{ transactionInfo.asset_code }}</p>
			</div>
			<span class="divide_line"></span>
			<div class="box_item">
				<p>{{ $t('merchant_management.payment_list.table.amount') }}</p>
				<p class="amount">
					{{ transactionInfo.amount }} {{ transactionInfo.asset_code }}
				</p>
			</div>
		</div>
		<p class="check_info">
			{{
				$t('merchant_management.payment_list.detail.check_refund_information')
			}}
		</p>
		<button class="merchant_button border_red" @click="refundTransaction">
			{{ $t('merchant_management.payment_list.detail.refund') }}
		</button>
	</ModalViewM>
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">
			{{ modalStatusMessage }}
		</p>
		<button class="merchant_button bg_red" @click="confirm">
			{{ $t('button.confirm') }}
		</button>
	</ModalMessageM>
</template>

<script>
import { fetchMerchantTransactionList } from '@/api/merchant';
import { commonError } from '@/common/dialog';
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import DetailSearchComponent from '@/components/Management/DetailSearchComponent';
import jwt from 'jsonwebtoken';
import { transactionRefund } from '@/api/pg';

export default {
	name: 'PaymentList',
	components: { ModalViewM, ModalMessageM, DetailSearchComponent },
	data() {
		return {
			startDate: this.$dayjs(new Date())
				.add(0, 'day')
				.set('hour', 0)
				.set('minute', 0)
				.set('second', 0)
				.toDate(),
			endDate: new Date(),
			transactionList: [],
			transactionInfo: {},
			isShowList: true,
			pageNavigation: {},
			curPage: 1,
			listCount: 4,
			detailSearchModal: false,
			checkRefundModal: false,
			messageModal: false,
			receivedSearchData: [],
			assetSeq: '',
			modalIcon: '',
			modalStatusMessage: '',
			isSuccess: false,
			apiSignature: this.$store.state.auth.merchantInfo.api_signature,
			merchantId: this.$store.state.auth.merchantInfo.merchant_id,
			summary: {
				count: 0,
				sum: 0,
			},
		};
	},
	computed: {
		completeCount() {
			return this.transactionList.filter(
				item => item.transaction_type === 'PAYMENT',
			).length;
		},
		refundCount() {
			return this.transactionList.filter(
				item => item.transaction_type === 'REFUND',
			).length;
		},
		isRemain() {
			return this.listCount >= this.pageNavigation.total_count;
		},
	},
	watch: {
		startDate() {
			this.loadTransactionList();
		},
		endDate() {
			this.loadTransactionList();
		},
	},
	methods: {
		back() {
			this.isShowList = true;
		},
		init() {
			Promise.all([this.loadTransactionList()]).catch(commonError);
		},
		async loadTransactionList() {
			const params = {
				...this.$route.query,
				...this.$route.params,
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				asset_seq: this.assetSeq,
				page: this.curPage,
				list_count: this.listCount,
			};

			const { data, page_navigation } = await fetchMerchantTransactionList(
				params,
			);

			this.transactionList = data;
			this.pageNavigation = page_navigation;
			this.getSummary();
		},
		getSummary() {
			let sum = 0;
			this.transactionList.forEach(item => {
				sum += item.amount * 1;
			});
			this.summary.count = this.transactionList.length;
			this.summary.sum = sum;
		},
		pageChangeHandler() {
			this.listCount += 4;
			this.loadTransactionList();
		},
		showDetail(transactionInfo) {
			this.transactionInfo = transactionInfo;
			this.isShowList = false;
		},
		searchData(params) {
			this.receivedSearchData = params;
			this.startDate = params.regdate_start;
			this.endDate = params.regdate_end;
			this.assetSeq = params.asset_seq;
			this.curPage = 1;
			this.loadTransactionList();
			this.detailSearchModal = false;
		},
		reLoad() {
			this.startDate = this.$dayjs(this.startDate).startOf('d').toDate();
			this.endDate = this.$dayjs(this.endDate).endOf('d').toDate();
		},
		refund() {},
		async refundTransaction() {
			this.token = jwt.sign(
				{
					info: {
						transaction_id: this.transactionInfo.transaction_id,
						amount: this.transactionInfo.amount,
					},
				},
				this.apiSignature,
			);
			const data = {
				merchant_id: this.merchantId,
				token: this.token,
			};
			await transactionRefund(data)
				.then(() => {
					this.modalStatusMessage = this.$t(
						'merchant_management.payment_list.detail.refund_complete',
					);
					this.modalIcon = 'success';
					this.messageModal = true;
					this.isSuccess = true;
				})
				.catch(err => {
					this.modalIcon = 'error';
					this.modalStatusMessage = err.message;
					this.messageModal = true;
					this.isSuccess = false;
				});
		},
		confirm() {
			this.messageModal = false;
			this.$router.go(0);
		},
	},
	created() {
		this.init();
	},
};
</script>

<style scoped></style>
